import React, { createContext, useContext, useState, useEffect } from 'react';
import { ownerAuth } from '../services/api';

const OwnerAuthContext = createContext(null);

export function OwnerAuthProvider({ children }) {
  const [owner, setOwner] = useState(null);
  const [unit, setUnit] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('owner_token');
    if (token) {
      ownerAuth.me()
        .then((res) => {
          setOwner(res.data.user);
          setUnit(res.data.unit);
        })
        .catch(() => localStorage.removeItem('owner_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await ownerAuth.login({ email, password });
    localStorage.setItem('owner_token', res.data.token);
    setOwner(res.data.user);
    setUnit(res.data.unit);
    return res.data;
  };

  const register = async (data) => {
    const res = await ownerAuth.register(data);
    localStorage.setItem('owner_token', res.data.token);
    setOwner(res.data.user);
    setUnit(res.data.unit);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('owner_token');
    setOwner(null);
    setUnit(null);
  };

  const refreshUnit = async () => {
    try {
      const res = await ownerAuth.me();
      setUnit(res.data.unit);
    } catch (_) {}
  };

  return (
    <OwnerAuthContext.Provider value={{ owner, unit, loading, login, register, logout, refreshUnit }}>
      {children}
    </OwnerAuthContext.Provider>
  );
}

export function useOwnerAuth() {
  return useContext(OwnerAuthContext);
}
